import React from "react";
import {HashRouter} from "react-router-dom";
import {ConfigProvider} from "antd";
import ruRU from "antd/es/locale/ru_RU";
import type {AppProvidersProps} from "./Providers.types";

export const AppProviders = ({children}: AppProvidersProps) => {
  return (
    <ConfigProvider locale={ruRU}>
      <HashRouter>
        {children}
      </HashRouter>
    </ConfigProvider>
  );
};